export enum DiagramStatus {
  Empty = 'empty',
  Changed = 'changed',
  Saved = 'saved',
  Published = 'published',
  PrePublish = 'pre-publish',
  Rejected = 'rejected',
}
